
              
        <div class="card">
            <div class="title">Kitchen Stock</div> 
  
                <form  [formGroup] ="form"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
  
                <div class="form-group">
                  <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
                  </div>
                <div class="col-sm-12 pb-1">
  
                <div class="row">
                  <div class="col-sm-12 mat-form-field-width">
                    <mat-form-field appearance="outline">
                      <mat-label>Name</mat-label>
                      <input [readonly]="isReadOnly" formControlName="name" [class.is-invalid]="formErrors.name" (blur)="logValidationErrors()" matInput placeholder="Name">                 
                      <mat-error *ngIf="formErrors.name">{{formErrors.name}}</mat-error>
                    </mat-form-field>             
                  </div>
                </div>
  
                <div class="row">
                  <div class="col-sm-12 mat-form-field-width">
                    <mat-form-field appearance="outline">
                      <mat-label>Unit</mat-label>
                      <mat-select formControlName="unit"  [class.is-invalid]="formErrors.unit">
                        <mat-option *ngFor="let item of UNIT" [value]="item.value">
                          {{item.value}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="formErrors.unit">{{formErrors.unit}}</mat-error>
                    </mat-form-field>             
                  </div>
                </div>
  
                <div class="row">
                  <div class="col-sm-12 mat-form-field-width">
                    <mat-form-field appearance="outline">
                      <mat-label>Unit Cost</mat-label>
                      <input  formControlName="unitCost" [class.is-invalid]="formErrors.unitCost" (blur)="logValidationErrors()" matInput placeholder="Unit Cost">                 
                      <mat-error *ngIf="formErrors.unitCost">{{formErrors.unitCost}}</mat-error>
                    </mat-form-field>             
                  </div>
                </div>
  

                  
                  <button mat-flat-button *ngIf="true" color="primary"  type="submit" class="float-right ml-2 mt-2">
                    <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Save
                  </button> 
                  <button type="button" (click)="onClose()" class="nofocus float-right mt-2" mat-stroked-button>Cancel</button>       
                  </div>    
  
              </form>
              
  
          </div>   <!-- /.card --> 
          
           <!-- Form Values : {{ form.value | json }}   -->
         
         
         
          
          
          
  
  
